<template>
  <span id='reports'>
    <!-- tenant == Yara Latam -->
    <div v-if="this.tenant == 'yaraltm'" class="md-layout">
      <!-- Conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" :class='tenant==this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("allConversations").url' baseUrl='/placeholder' :filter='mountUrlAndParams("allConversations").filter' @success='setChartSimpleData("allConversations", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="blue">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-comments"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.conversations')}}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value="allConversations"
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Tempo médio de conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" :class='tenant==this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("agvTimeConversation").url' baseUrl='/placeholder' :filter='mountUrlAndParams("agvTimeConversation").filter' @success='setAvgTimeConversation($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="green">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-stopwatch"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.agvTimeConversation')}}</p>
                <h3 class="title">
                  <animated-number
                    isDecimal
                    :value="agvTimeConversation"
                  ></animated-number>
                  <span>min</span>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Média de Interações/Conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" :class='tenant==this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("avgInteraction").url' baseUrl='/placeholder' :filter='mountUrlAndParams("avgInteraction").filter' @success='setAvgInteraction($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="warning">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-chart-bar"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.agvInteractionsConversations')}}</p>
                <h3 class="title">
                  <animated-number
                    isDecimal
                    :value="avgInteraction || 0"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Usuários não autenticados -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" v-if="isDashboardSelect (tenant) && tenant !== 'sefmg'">
        <DataProvider :endpoint='mountUrlAndParams("totalUserNotAuthenticated").url' baseUrl='/placeholder' :filter='mountUrlAndParams("totalUserNotAuthenticated").filter' @success='setChartSimpleData("totalUserNotAuthenticated", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="danger">
              <template slot="header">
                <div class="card-icon">
                  <i class="fa-solid fa-right-to-bracket"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.unauthenticatedUsers')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="totalUserNotAuthenticated"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>
    </div>

    <!-- tenant != Yara Latam -->
    <div v-if="this.tenant != 'yaraltm'" class="md-layout">
      <!-- Conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 " :class='tenant==this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("allConversations").url' baseUrl='/placeholder' :filter='mountUrlAndParams("allConversations").filter' @success='setChartSimpleData("allConversations", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="blue">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-comments"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.conversations')}}</p>
                <h3 class="title">
                  <div>
                    <animated-number
                      :value="allConversations"
                    ></animated-number>
                  </div>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Interações -->
      <div v-if="!isDashboardSelect (tenant)" class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
        <DataProvider :endpoint='mountUrlAndParams("allInteractions").url' baseUrl='/placeholder' :filter='mountUrlAndParams("allInteractions").filter' @success='setChartSimpleData("allInteractions", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="rose">
              <template slot="header">
                <div class="card-icon">
                  <i class="far fa-comment-dots"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.interactions')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="allInteractions"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Tempo médio de conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" :class='tenant === this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("agvTimeConversation").url' baseUrl='/placeholder' :filter='mountUrlAndParams("agvTimeConversation").filter' @success='setAvgTimeConversation($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="green">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-stopwatch"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.agvTimeConversation')}}</p>
                <h3 class="title">
                  <animated-number
                    isDecimal
                    :value="agvTimeConversation"
                  ></animated-number>
                  <span>min</span>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- Média de Interações/Conversas -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100" :class='tenant==this.tenant ? "md-size-36": "md-size-25"'>
        <DataProvider :endpoint='mountUrlAndParams("avgInteraction").url' baseUrl='/placeholder' :filter='mountUrlAndParams("avgInteraction").filter' @success='setAvgInteraction($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="warning">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-chart-bar"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.agvInteractionsConversations')}}</p>
                <h3 class="title">
                  <animated-number
                    isDecimal
                    :value="avgInteraction || 0"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>
    </div>

    <div class="md-layout">
      <!-- Usuários não autenticados -->
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-36" v-if="isDashboardSelect (tenant) && this.tenant != 'yaraltm' && tenant !== 'sefmg'">
        <DataProvider :endpoint='mountUrlAndParams("totalUserNotAuthenticated").url' baseUrl='/placeholder' :filter='mountUrlAndParams("totalUserNotAuthenticated").filter' @success='setChartSimpleData("totalUserNotAuthenticated", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="danger">
              <template slot="header">
                <div class="card-icon">
                  <i class="fa-solid fa-right-to-bracket"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.unauthenticatedUsers')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="totalUserNotAuthenticated"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- CNPJ Atendidos -->
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-36"
        v-if="isDashboardSelect (tenant) && this.tenant != 'yaraltm' && tenant !== 'sefmg'"
      >
        <DataProvider :endpoint='mountUrlAndParams("totalAttendedCnpj").url' baseUrl='/placeholder' :filter='mountUrlAndParams("totalAttendedCnpj").filter' @success='setChartSimpleData("totalAttendedCnpj", $event)'>
          <!-- eslint-disable-next-line   -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="blue">
              <template slot="header">
                <div class="card-icon">
                  <i class="fas fa-building"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.cnpjAttended')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="totalAttendedCnpj"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>

      <!-- media de intenções/conversa  -->
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-36"
        v-if="isDashboardSelect (tenant) && this.tenant != 'yaraltm'"
      >
        <DataProvider :endpoint='mountUrlAndParams("avgIntention").url' baseUrl='/placeholder' :filter='mountUrlAndParams("avgIntention").filter' @success='setChartSimpleData("avgIntention", $event)'>
          <!-- eslint-disable-next-line   -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else>
              <template slot="header">
                <div style="background-color: #9346A4;" class="card-icon">
                  <IconNetworkIntelligence />
                </div>
                <p class="category">{{$t('managementAccess.intentionAverage')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="avgIntention"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>
    </div>

    <div style="max-width: 33.3%;" class="md-layout">
      <!-- CPF Atendidos -->
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-34"
        v-if="isDashboardSelect (tenant) && this.tenant != 'yaraltm' && tenant !== 'sefmg'"
      >
        <DataProvider :endpoint='mountUrlAndParams("totalAttendedCpf").url' baseUrl='/placeholder' :filter='mountUrlAndParams("totalAttendedCpf").filter' @success='setChartSimpleData("totalAttendedCpf", $event)'>
          <!-- eslint-disable-next-line   -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              height="110"
              style='margin: 30px 0;'
              type="list-item-avatar-three-line"
            >
            </v-skeleton-loader>
            <stats-card v-else header-color="green">
              <template slot="header">
                <div class="card-icon">
                  <i class="fa-regular fa-address-card"></i>
                </div>
                <p class="category">{{$t('dashboardGeneral.cpfAttended')}}</p>
                <h3 class="title">
                  <animated-number
                    :value="totalAttendedCpf"
                  ></animated-number>
                </h3>
              </template>
            </stats-card>
          </div>
        </DataProvider>
      </div>
    </div>

    <div class="md-layout">
      <!-- ################### Quantidade de Conversas por Dia -->
      <div class="md-layout-item md-size-100" >
        <DataProvider :endpoint='mountUrlAndParams("qtyConversationsDay").url' baseUrl='/placeholder' :filter='mountUrlAndParams("qtyConversationsDay").filter' @success='setQtyConversationsDay($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else>
              <template v-if='error || qtyConversationsDay.data.series[0].length === 0'>
                <CardNoData :title="$t('dashboardGeneral.numberOfConversationsPerDay')" :error='error' height='463' />
              </template>
              <chart-card
                v-else
                :key='qtyConversationsDayKey'
                header-animation="false"
                :chart-data="qtyConversationsDay.data"
                :chart-options="qtyConversationsDay.options"
                chart-type="Line"
                header-icon
                chart-inside-content
                no-footer
                background-color="green"
                classNameComponent="dashboardGeneralChart"
              >
                <template slot="chartInsideHeader">
                  <h4 class="title">{{$t('dashboardGeneral.numberOfConversationsPerDay')}}</h4>
                </template>
              </chart-card>
            </template>
          </div>
        </DataProvider>
      </div>

      <!-- ################### Quantidade de e interações e conversas por data e horário -->
      <div class="md-layout-item md-size-100" v-if="isDashboardSelect (tenant)">
        <DataProvider :endpoint='mountUrlAndParams("amountConversationInteraction").url' baseUrl='/placeholder' :filter='mountUrlAndParams("amountConversationInteraction").filter' @success='setAmountConversationInteraction($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else>
              <template v-if='error || amountConversationInteractionDay.data.series[0].length === 0'>
                <CardNoData :title="$t('dashboardGeneral.numberOfInteractions')" :error='error' height='463' />
              </template>
              <chart-card v-cloak
                v-else
                :key='amountConversationInteractionKey'
                header-animation="false"
                :chart-data="amountConversationInteractionDay.data"
                :chart-options="amountConversationInteractionDay.options"
                chart-type="Line"
                header-icon
                chart-inside-content
                background-color="green"
                classNameComponent="dashboardGeneralChart"
                class='amount-conversation-interaction'
              >
                <template slot="chartInsideHeader">
                  <h4 class="title">{{$t('dashboardGeneral.numberOfInteractions')}}</h4>
                </template>
                <template slot="footer">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                      <md-checkbox v-model="showPointLabel" @change="changePointLabel($event)">{{$t('dashboardGeneral.showChartPointLabel')}}</md-checkbox>
                    </div>
                    <div class="md-layout-item">
                      <span >
                        <i class="fa fa-circle color-blue-olive"></i>
                          {{$t('dashboardGeneral.interactions')}}
                      </span>
                      <span >
                        <i class="fa fa-circle color-blue-50"></i>
                          {{$t('dashboardGeneral.conversations')}}
                      </span>
                    </div>
                  </div>
                </template>
              </chart-card>
            </template>
          </div>
        </DataProvider>
      </div>

      <!-- Gráfico Quantidade de Acessos por site -->
      <div class="md-layout-item md-size-100 mx-auto" v-if="this.tenant == 'sefmg'">
        <DataProvider :endpoint='mountUrlAndParams("qtyConversationsByHost").url' baseUrl='/placeholder' :filter='mountUrlAndParams("qtyConversationsByHost").filter' @success='setQtyConversationsByHost($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              style='margin: 30px 0;'
              type="card-heading, list-item-three-line, list-item-three-line, list-item-three-line"
            >
            </v-skeleton-loader>
            <template v-else-if='error || qtyConversationsByHost.data.series[0].length === 0'>
              <CardNoData :title="$t('managementAccess.accessesBySite')" :error='error' height='380' />
            </template>
            <chart-card
              v-else
              :key='qtyConversationsByHostKey'
              header-animation="false"
              :chart-data="qtyConversationsByHost.data"
              :chart-options="qtyConversationsByHost.options"
              chart-type="Bar"
              header-icon
              chart-inside-content
              no-footer
              background-color="green"
              style='padding-right: 100px;'
              classNameComponent="efficiencyChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('managementAccess.accessesBySite')}}</h4>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ################### Quantidade de Conversas por Hora e Dia da Semana -->
      <div class="md-layout-item md-size-100" v-if="!isDashboardSelect (tenant)">
        <DataProvider :endpoint='mountUrlAndParams("qtyConversationsHourWeek").url' baseUrl='/placeholder' :filter='mountUrlAndParams("qtyConversationsHourWeek").filter' @success='setQtyConversationsHourWeek($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='error'>
              <CardNoData :title="$t('dashboardGeneral.numberOfConversationsPerHour')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              :key='qtyConversationsHourWeekKey'
              header-animation="false"
              :chart-data="qtyConversationsHourWeek.data"
              :chart-options="qtyConversationsHourWeek.options"
              chart-type="Bar"
              header-icon
              chart-inside-content
              background-color="blue"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">
                  {{$t('dashboardGeneral.numberOfConversationsPerHour')}}
                </h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <i class="fa fa-circle text-info"></i>{{$t('dashboardGeneral.monday')}}
                    <i class="fa fa-circle text-danger"></i>{{$t('dashboardGeneral.tuesday')}}
                    <i class="fa fa-circle text-warning"></i>{{$t('dashboardGeneral.wednesday')}}
                    <i class="fa fa-circle text-primary"></i>{{$t('dashboardGeneral.thursday')}}
                    <i class="fa fa-circle text-success"></i>{{$t('dashboardGeneral.friday')}}
                    <i class="fa fa-circle" style='color: #ea4c89'></i>{{$t('dashboardGeneral.saturday')}}
                    <i class="fa fa-circle text-github"></i>{{$t('dashboardGeneral.sunday')}}
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ################### Top 10 CPF mais atendidos -->
      <div class="md-layout-item md-size-50 mx-auto" v-if="isRegularize || isDemo">
        <DataProvider
            :endpoint='mountUrlAndParams("topTenAttendedCpf").url'
            :filter='mountUrlAndParams("topTenAttendedCpf").filter'  baseUrl='/placeholder'>
          <div slot-scope='{ data: response, loading }'>
            <DataTable
              v-if='response && response.data'
              :data='response && response.data'
              ref='dataTable'
              :title="$t('dashboardGeneral.top10AttendedCpf')"
              :customTotal='(response && response.total) || 0'
              currentSort.sync='total'
              currentSortOrder.sync='desc'
              :selectable='false'
              excludeHeader
              :loading='loading'
              :endpoint='mountUrlAndParams("topTenAttendedCpf").url'
              :filter='mountUrlAndParams("topTenAttendedCpf").filter'
              :labels='labelsCpf'
              :formatLabelFunction='formatLabels'
              :fileName="$t('dashboardGeneral.fileNameTop10AttendedCpf')"
            >
              <template slot='cells' slot-scope='{ item }'>
                <md-table-cell :md-label='labelsCpf[0]' >
                    {{ formatLabels(item, 0) }}
                </md-table-cell>
                <md-table-cell :md-label='labelsCpf[1]' >
                    {{ formatLabels(item, 1) }}
                </md-table-cell>
              </template>

            </DataTable>
          </div>
        </DataProvider>
      </div>

      <!-- ################### Top 10 CNPJ mais atendidos -->
      <div class="md-layout-item md-size-50 mx-auto" v-if="isRegularize || isDemo">
        <DataProvider
            :endpoint='mountUrlAndParams("topTenAttendedCnpj").url'
            :filter='mountUrlAndParams("topTenAttendedCnpj").filter'  baseUrl='/placeholder'>
          <div slot-scope='{ data: response, loading }'>
            <DataTable
              v-if='response && response.data'
              :data='response && response.data'
              ref='dataTable'
              :title="$t('dashboardGeneral.top10AttendedCnpj')"
              :customTotal='(response && response.total) || 0'
              currentSort.sync='total'
              currentSortOrder.sync='desc'
              :selectable='false'
              excludeHeader
              :loading='loading'
              :endpoint='mountUrlAndParams("topTenAttendedCnpj").url'
              :filter='mountUrlAndParams("topTenAttendedCnpj").filter'
              :labels='labelsCnpj'
              :formatLabelFunction='formatLabels'
              :fileName="$t('dashboardGeneral.fileNameTop10AttendedCnpj')"
            >
              <template slot='cells' slot-scope='{ item }'>
                <md-table-cell :md-label='labelsCnpj[0]' >
                    {{ formatLabels(item, 0) }}
                </md-table-cell>
                <md-table-cell :md-label='labelsCnpj[1]' >
                    {{ formatLabels(item, 1) }}
                </md-table-cell>
              </template>

            </DataTable>
          </div>
        </DataProvider>
      </div>

      <!-- ############################## Canais Sim/Nào -->
      <div class="md-layout-item md-size-50 mx-auto" v-if="isDashboardSelect (tenant)">
        <DataProvider :endpoint='mountUrlAndParams("percentResolvedInteraction").url' baseUrl='/placeholder' :filter='mountUrlAndParams("percentResolvedInteraction").filter' @success='setPercentResolvedInteraction($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='(yes_no.data.series.length === 0 && yes_no.data.series.length === 0 || yes_no.data.series[0].value === 0 && yes_no.data.series[1].value === 0)'>
              <CardNoData :title="$t('dashboardGeneral.percentageOfInformation')" :error='error' height='408' />
            </template>
            <chart-card
              v-else
              :key='percentResolvedInteractionKey'
              header-animation="false"
              :chart-data="yes_no.data"
              :chart-options="yes_no.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
              classNameComponent="percentChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.percentageOfInformation')}}</h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <span v-for='(label, i) in yes_no.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <div class="md-layout-item md-size-50 mx-auto" v-if="isSefMg">
        <DataProvider :endpoint='mountUrlAndParams("percentResolvedInteractionKnowledge").url' baseUrl='/placeholder' :filter='mountUrlAndParams("percentResolvedInteractionKnowledge").filter' @success='setPercentResolvedInteractionKnowledge($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='(yes_no_kb.data.series.length === 0 && yes_no_kb.data.series.length === 0 || yes_no_kb.data.series[0].value === 0 && yes_no_kb.data.series[1].value === 0)'>
              <CardNoData :title="$t('dashboardGeneral.percentageOfInformationKnowledge')" :error='error' height='408' />
            </template>
            <chart-card
              v-else
              :key='percentResolvedInteractionKnowledgeKey'
              header-animation="false"
              :chart-data="yes_no_kb.data"
              :chart-options="yes_no_kb.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
              classNameComponent="percentChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.percentageOfInformationKnowledge')}}</h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <span v-for='(label, i) in yes_no_kb.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <div class="md-layout-item md-size-50 mx-auto" v-if="isSefMg">
        <DataProvider :endpoint='mountUrlAndParams("percentResolvedInteractionBoth").url' baseUrl='/placeholder' :filter='mountUrlAndParams("percentResolvedInteractionBoth").filter' @success='setPercentResolvedInteractionBoth($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='(yes_no_both.data.series.length === 0 && yes_no_both.data.series.length === 0 || yes_no_both.data.series[0].value === 0 && yes_no_both.data.series[1].value === 0)'>
              <CardNoData :title="$t('dashboardGeneral.percentageOfInformationBoth')" :error='error' height='408' />
            </template>
            <chart-card
              v-else
              :key='percentResolvedInteractionBothKey'
              header-animation="false"
              :chart-data="yes_no_both.data"
              :chart-options="yes_no_both.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
              classNameComponent="percentChart"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.percentageOfInformationBoth')}}</h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <span v-for='(label, i) in yes_no_both.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ############################## Canais Donut -->
      <div class="md-layout-item md-size-50 mx-auto" v-if="!isDashboardSelect (tenant)">
        <DataProvider :endpoint='mountUrlAndParams("channel").url' baseUrl='/placeholder' :filter='mountUrlAndParams("channel").filter' @success='setChannelOrOs("channel", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='error || channel.data.label.length === 0'>
              <CardNoData :title="$t('dashboardGeneral.channels')" :error='error' height='408' />
            </template>
            <chart-card
              v-else
              :key='channelKey'
              header-animation="false"
              :chart-data="channel.data"
              :chart-options="channel.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.channels')}}</h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <span v-for='(label, i) in channel.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ############################## Sistema Operacional -->
      <div v-if='!isDashboardSelect (tenant)' class="md-layout-item md-size-50 mx-auto">
        <DataProvider :endpoint='mountUrlAndParams("os").url' baseUrl='/placeholder' :filter='mountUrlAndParams("os").filter' @success='setChannelOrOs("os", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='error || os.options.labels.length === 0'>
              <CardNoData :title="$t('dashboardGeneral.operationalSystem')" :error='error' height='408' />
            </template>
            <chart-card
              v-else
              :key='osKey'
              header-animation="false"
              :chart-data="os.data"
              :chart-options="os.options"
              chart-type="Pie"
              header-icon
              chart-inside-content
              background-color="green"
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.operationalSystem')}}</h4>
              </template>
              <template slot="footer">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <span v-for='(label, i) in os.options.labels' :key='i'>
                      <i class="fa fa-circle" :class='labelColor(i)'></i>
                      {{ label }}
                    </span>
                  </div>
                </div>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ############################## TOP 10 INTENÇÕES v-if='tenant!="regularize"' -->
      <div class="md-layout-item md-size-100 mx-auto" v-if='isSefMg || isDanese'>
        <DataProvider :endpoint='mountUrlAndParams("highestIntentions").url' baseUrl='/placeholder' :filter='mountUrlAndParams("highestIntentions").filter' @success='setHighestIntentions("highestIntentions", $event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <v-skeleton-loader
              v-if="loading"
              style='margin: 30px 0;'
              type="card-heading, list-item-three-line, list-item-three-line, list-item-three-line"
            >
            </v-skeleton-loader>
            <template v-else-if='error || highestIntentions.data.series[0].length === 0'>
              <CardNoData :title="$t('dashboardGeneral.top10Intentions')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              :key='highestIntentionsKey'
              header-animation="false"
              :chart-data="highestIntentions.data"
              :chart-options="highestIntentions.options"
              chart-type="Bar"
              header-icon
              chart-inside-content
              no-footer
              background-color="green"
              style='padding-right: 100px;'
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.top10Intentions')}}</h4>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>

      <!-- ############################## NUVEM DE PALAVRAS - OBS VER CSS no final do arquivo -->
      <div  v-if="isSefMg || isDanese" class="md-layout-item mx-auto md-size-100">
        <DataProvider :endpoint='mountUrlAndParams("wordsCloud").url' baseUrl='/placeholder' :filter='mountUrlAndParams("wordsCloud").filter' @success='setWordsCloud($event)'>
          <!-- eslint-disable-next-line -->
          <div slot-scope='{ data: response, error, loading }'>
            <SkeletonLoaderChart v-if="loading"/>
            <template v-else-if='error || wordsCloud.words.length === 0'>
              <CardNoData :title="$t('dashboardGeneral.wordCloud')" :error='error' height='463' />
            </template>
            <chart-card
              v-else
              :key='wordsCloudKey'
              header-animation="false"
              header-icon
              no-footer
              background-color="green"
              :isChart='false'
            >
              <template slot="chartInsideHeader">
                <h4 class="title">{{$t('dashboardGeneral.wordCloud')}}</h4>
                <cloud
                  :data="wordsCloud.words"
                  :fontSizeMapper="wordsCloud.fontSizeMapper"
                  :height="tenant == 'regularize' ? 330: 400"
                  :width="600"
                  :rotate="wordsCloud.rotate"
                  :padding="6"
                  :onWordClick="(word) => {}"
                ></cloud>
              </template>
            </chart-card>
          </div>
        </DataProvider>
      </div>
      <div v-if="isDataPrev" class="md-layout-item mx-auto md-size-100">
        <DataProvider
          :endpoint='mountUrlAndParams("evaluationSLO").url'
          :filter='mountUrlAndParams("evaluationSLO").filter'  baseUrl='/placeholder'>
          <div slot-scope='{ data: response, loading }'>
            <DataTable
              class="evaluationSLO"
              v-if='response && response.data'
              :data='response && response.data'
              ref='dataTable'
              :title="'Avaliação de SLO'"
              :customTotal='(response && response.total) || 0'
              currentSort.sync='total'
              currentSortOrder.sync='desc'
              :selectable='false'
              excludeHeader
              :loading='loading'
              :endpoint='mountUrlAndParams("evaluationSLO").url'
              :filter='mountUrlAndParams("evaluationSLO").filter'
              :labels='labelsRatingSLO'
            >
              <template slot='cells' slot-scope='{ item }'>
                <md-table-cell :md-label='labelsRatingSLO[0]' >
                    {{ item.serviceQueue }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[1]' >
                    {{ item.totalConversation }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[2]' >
                    {{ item.resolved }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[3]' >
                    {{ item.partiallyResolved }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[4]' >
                    {{ item.notResolved }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[5]' >
                    {{ item.withoutEvaluation }}
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[6]' >
                    {{ item.currentSLO }}%
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[7]' >
                    {{ item.goalSLO }}%
                </md-table-cell>
                <md-table-cell :md-label='labelsRatingSLO[8]' >
                  <v-icon :color="getStatusColorSLO(item.currentSLO, item.goalSLO)">{{ getStatusSLO(item.currentSLO, item.goalSLO) }}</v-icon>
                </md-table-cell>
              </template>
            </DataTable>
          </div>
        </DataProvider>
      </div>
    </div>
  </span>
</template>

<script>
import Cloud from 'vue-d3-cloud'
import AnimatedNumber from '@/components/AnimatedNumber.vue'
import StatsCard from '@/components/Cards/StatsCard.vue'
import DataProvider from '@/components/DataProvider'
import SkeletonLoaderChart from '@/components/Reuse/SkeletonLoaderChart'
import CardNoData from '@/components/CardNoData'
import DataTable from '@/components/DataTable'
import { selectedLocale } from '@/plugins/i18n'
import IconNetworkIntelligence from '@/assets/img/network_intelligence.svg'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapFields } from 'vuex-map-fields'

let qtdConversationsHourWeek = {
  labels: [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23'
  ],

  series: [
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 1 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 1 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 3 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 1 },
      { meta: '7h', value: 10 },
      { meta: '8h', value: 1 },
      { meta: '9h', value: 3 },
      { meta: '10h', value: 2 },
      { meta: '11h', value: 1 },
      { meta: '12h', value: 3 },
      { meta: '13h', value: 2 },
      { meta: '14h', value: 1 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 2 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 1 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 2 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ],
    [
      { meta: '0h', value: 0 },
      { meta: '1h', value: 0 },
      { meta: '2h', value: 0 },
      { meta: '3h', value: 0 },
      { meta: '4h', value: 0 },
      { meta: '5h', value: 0 },
      { meta: '6h', value: 0 },
      { meta: '7h', value: 0 },
      { meta: '8h', value: 0 },
      { meta: '9h', value: 0 },
      { meta: '10h', value: 0 },
      { meta: '11h', value: 0 },
      { meta: '12h', value: 0 },
      { meta: '13h', value: 0 },
      { meta: '14h', value: 0 },
      { meta: '15h', value: 0 },
      { meta: '16h', value: 0 },
      { meta: '17h', value: 0 },
      { meta: '18h', value: 0 },
      { meta: '19h', value: 0 },
      { meta: '20h', value: 0 },
      { meta: '21h', value: 0 },
      { meta: '22h', value: 0 },
      { meta: '23h', value: 0 }
    ]
  ]
}

export default {
  components: {
    IconNetworkIntelligence,
    StatsCard,
    ChartCard: () => import('@/components/Cards/ChartCard.vue'),
    AnimatedNumber,
    cloud: Cloud,
    DataProvider,
    SkeletonLoaderChart,
    CardNoData,
    DataTable
  },
  mixins: [isTenantMixin],
  data () {
    return {
      labelsCpf: [ 'CPF', 'Conversas' ],
      labelsCnpj: [ 'CNPJ', 'Conversas' ],
      labelsRatingSLO: [
        'Fila de Atendimento',
        'Total de Conversas',
        'Resolvida Totalmente',
        'Resolvida Parcialmente',
        'Não Resolvida',
        'Sem avaliação',
        'SLO Atual',
        'SLO Meta',
        'Status' ],
      tenant: '',
      baseURL: '',
      // date Interval
      chatDate: {
        d1: new Date().toISOString().substr(0, 10),
        d2: new Date().toISOString().substr(0, 10),
        t1: null,
        t2: null
      },
      showPointLabel: true,
      allConversations: 0,
      allInteractions: 0,
      totalUserNotAuthenticated: 0,
      totalAttendedCpf: 0,
      totalAttendedCnpj: 0,
      agvTimeConversation: 0,
      avgInteraction: 0,
      avgIntention: 0,
      amountConversationInteractionDay: {
        data: {
          labels: [],
          series: [[], []]
        },
        options: {
          height: 400,
          width: '97%',
          showArea: true,
          showPoint: true,
          showLine: true,
          axisX: {
            showGrid: false
          },
          lineSmooth: this.$Chartist.Interpolation.none(),
          // classNames: {
          //   line: 'customLine2Line'
          // },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctPointLabels({
                labelClass: 'custom-point-label',
                textAnchor: 'middle',
                labelInterpolationFnc: (value) => { if (typeof value === 'undefined') return ''; else return value }
              })
              .bind(this)
          ]
        }
      },
      qtyConversationsDay: {
        data: {
          labels: ['14/01', '15/01', '20/02', '01/04'],
          series: [
            [
              { meta: '14/01', value: 2 },
              { meta: '15/01', value: 11 },
              { meta: '20/02', value: 3 },
              { meta: '01/04', value: 18 }
            ]
          ]
        },
        options: {
          height: 400,
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1
          }),
          classNames: {
            line: 'customLine',
            label: 'customLabel'
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctPointLabels({
                textAnchor: 'middle'
              })
              .bind(this)
          ]
        }
      },
      qtyConversationsHourWeek: {
        data: {
          labels: qtdConversationsHourWeek.labels,
          series: qtdConversationsHourWeek.series
        },
        options: {
          height: 400,
          stackBars: true,
          axisX: {
            labelInterpolationFnc: function (value) {
              return value + 'h'
            }
          },
          axisY: {
            onlyInteger: true,
            labelInterpolationFnc: function (value) {
              return value
            }
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctBarLabels({
                labelOffset: {
                  y: -4
                }
              })
              .bind(this)
          ]
        }
      },
      highestIntentions: {
        data: {
          labels: [
            'Reportar_Vazamento',
            'Reportar_FaltaDeAgua_abcdef',
            'General_Greetings',
            'Consultar_MatriculaCPF_aaaaaaaaaa',
            'Qualidade_Agua'
          ],
          series: [
            [
              { meta: 'Reportar_Vazamento', value: 1 },
              { meta: 'Reportar_FaltaDeAgua_abcdef', value: 3 },
              { meta: 'General_Greetings', value: 1 },
              { meta: 'Consultar_MatriculaCPF_aaaaaaaaaa', value: 1 },
              { meta: 'Qualidade_Agua', value: 1 }
            ]
          ]
        },
        options: {
          height: 300,
          seriesBarDistance: 10,
          reverseData: false,
          horizontalBars: true,
          labelDirection: 'explode',
          axisX: {
            showGrid: false,
            onlyInteger: true
          },
          axisY: {
            offset: 170,
            labelInterpolationFnc: function ellipsisLabel (
              value,
              index,
              chart
            ) {
              const max = 25
              const textWidth = function (str) {
                let thinChars =
                  str.length - str.replace(/[|^|i|I|l|1|.|,|'|]/g, '').length
                return str.length - Math.ceil(thinChars / 2)
              }
              if (textWidth(value) <= max) return value

              // Start by chopping off at the word before max
              // This is an over-approximation due to thin-characters...
              let end = value.lastIndexOf(' ', max - 3)

              // Just one long word. Chop it off.
              if (end === -1) return value.substring(0, max - 3) + '...'

              // Step forward as long as textWidth allows.
              let newEnd = end
              do {
                end = newEnd
                newEnd = value.indexOf(' ', end + 1)

                // No more spaces.
                if (newEnd === -1) newEnd = value.length
              } while (textWidth(value.substring(0, newEnd) + '...') < max)
              return value.substring(0, end) + '...'
            }
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctBarLabels({
                labelOffset: {
                  x: 4
                }
              })
              .bind(this)
          ]
        }
      },
      wordsCloud: {
        words: [],
        fontSizeMapper: (word) => Math.log2(word.value) * 8,
        rotate: (word) => word.value % 1
      },
      channel: {
        data: {
          series: [
            { meta: 'WebChat', value: 20 },
            { meta: 'Telegram', value: 10 },
            { meta: 'Facebook', value: 30 },
            { meta: 'WhatsApp', value: 40 },
            { meta: 'WhatsApp', value: 40 },
            { meta: 'WhatsApp', value: 40 },
            { meta: 'WhatsApp', value: 40 }
          ],
          label: ['WebChat', 'Facebook', 'WhatsApp', 'Telegram', 'WhatsApp', 'WhatsApp', 'WhatsApp']
        },
        options: {
          labels: ['WebChat', 'Facebook', 'WhatsApp', 'Telegram', 'WhatsApp', 'WhatsApp', 'WhatsApp'],
          donut: true,
          donutWidth: 50,
          fullWidth: true,
          height: 300,
          showLabel: true,
          classNames: {
            label: 'customLabel'
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this)
          ]
        }
      },
      os: {
        data: {
          series: [{ meta: 'Windows', value: 23 }, { meta: 'iOS', value: 31 }, { meta: 'Android', value: 2 }, { meta: 'Linux', value: 40 }]
        },
        options: {
          labels: ['Android', 'iOS', 'Windows', 'Linux'],
          donut: true,
          donutWidth: 50,
          fullWidth: true,
          height: 300,
          showLabel: true,
          classNames: {
            label: 'customLabel'
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this)
          ]
        }
      },
      yes_no: {
        data: {
          series: [{ meta: this.$t('dashboardGeneral.yes'), value: 23 }, { meta: this.$t('dashboardGeneral.no'), value: 31 }]
        },
        options:
        {
          labels: [this.$t('dashboardGeneral.yes'), this.$t('dashboardGeneral.no')],
          donut: true,
          donutWidth: 50,
          fullWidth: true,
          height: 300,
          showLabel: true,
          labelInterpolationFnc: (value) => { return value + '%' },
          //  classNames: {
          //    label: 'customLabel'
          //  },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this)
          ]
        }
      },
      yes_no_kb: {
        data: {
          series: [{ meta: this.$t('dashboardGeneral.yes'), value: 23 }, { meta: this.$t('dashboardGeneral.no'), value: 31 }]
        },
        options:
        {
          labels: [this.$t('dashboardGeneral.yes'), this.$t('dashboardGeneral.no')],
          donut: true,
          donutWidth: 50,
          fullWidth: true,
          height: 300,
          showLabel: true,
          labelInterpolationFnc: (value) => { return value + '%' },
          //  classNames: {
          //    label: 'customLabel'
          //  },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this)
          ]
        }
      },
      yes_no_both: {
        data: {
          series: [{ meta: this.$t('dashboardGeneral.yes'), value: 23 }, { meta: this.$t('dashboardGeneral.no'), value: 31 }]
        },
        options:
        {
          labels: [this.$t('dashboardGeneral.yes'), this.$t('dashboardGeneral.no')],
          donut: true,
          donutWidth: 50,
          fullWidth: true,
          height: 300,
          showLabel: true,
          labelInterpolationFnc: (value) => { return value + '%' },
          //  classNames: {
          //    label: 'customLabel'
          //  },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this)
          ]
        }
      },
      qtyConversationsByHost: {
        data: {
          labels: [],
          series: [
            []
          ]
        },
        options: {
          height: 300,
          seriesBarDistance: 20,
          reverseData: false,
          horizontalBars: true,
          labelDirection: 'explode',
          axisX: {
            showGrid: false,
            onlyInteger: true
          },
          axisY: {
            offset: 170
          },
          plugins: [
            this.$chartist.plugins
              .tooltip({
                anchorToPoint: true,
                seriesName: true,
                tooltipFnc: this.mountTooltip
              })
              .bind(this),
            this.$chartist.plugins
              .ctBarLabels({
                labelOffset: {
                  x: 4
                }
              })
              .bind(this)
          ]
        }
      },
      timeOut: null,
      amountConversationInteractionKey: 0,
      qtyConversationsDayKey: 1,
      qtyConversationsByHostKey: 2,
      qtyConversationsHourWeekKey: 3,
      percentResolvedInteractionKey: 4,
      channelKey: 5,
      highestIntentionsKey: 6,
      osKey: 7,
      wordsCloudKey: 8,
      percentResolvedInteractionKnowledgeKey: 9,
      percentResolvedInteractionBothKey: 10
    }
  },
  computed: {
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    formatDocument (document) {
      if (document.length === 11) {
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/,
          (regex, arg1, arg2, arg3, arg4) => {
            return arg1 + '.' + arg2 + '.' + arg3 + '-' + arg4
          })
      }
      return document.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/,
        (regex, arg1, arg2, arg3, arg4, arg5) => {
          return arg1 + '.' + arg2 + '.' + arg3 + '/' + arg4 + '-' + arg5
        })
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDocument(item.key)
        case 1:
          return item.total
        default:
          return '-'
      }
    },
    getStatusSLO (value, goal) {
      if (value >= goal) {
        return 'mdi-checkbox-marked'
      }
      if (value >= 30 && value < goal) {
        return 'mdi-alert-box'
      }
      if (value < 30) {
        return 'mdi-close-box'
      }
    },
    getStatusColorSLO (value, goal) {
      if (value >= goal) {
        return '#4caf50'
      }
      if (value >= 30 && value < goal) {
        return '#ff9800'
      }
      if (value < 30) {
        return '#f44336'
      }
    },

    mountUrlAndParams (endpoint) {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      const select = this.dateInterval.select?.value
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/reports/${endpoint}`,
        filter: { to, from, select: select }
      }
    },
    setChartSimpleData (key, response) {
      this[key] = response.data[key]
    },
    setAvgTimeConversation (response) {
      this.agvTimeConversation = response.data.averageTimeConversations.toFixed(2)
    },
    setAvgInteraction (response) {
      this.avgInteraction = response.data.agvInteraction.toFixed(2)
    },
    setQtyConversationsDay (response) {
      this.qtyConversationsDayKey++
      const { qtyConversationsDay } = response.data
      const { series, labels } = qtyConversationsDay
      const itemArr = []
      const formattedLabels = []

      const dateOptions = { year: 'numeric', month: '2-digit', day: '2-digit' }
      for (let i = 0; i < series[0].length; i++) {
        const value = series[0][i]
        const label = labels[i]
        if (label) {
          const meta = new Date(label.slice(0, 10)).toLocaleDateString(selectedLocale, dateOptions).slice(0, -5)
          itemArr.push({ meta, value })
          formattedLabels.push(meta)
        }
      }
      this.qtyConversationsDay.data.series = [itemArr]
      this.qtyConversationsDay.data.labels = formattedLabels
    },
    setQtyConversationsHourWeek (response) {
      this.qtyConversationsHourWeekKey++
      let seriesArr = []
      let itemArr = []
      for (let i = 0; i < response.data.qtyConversationsHourWeek.length; i++) {
        for (let j = 0; j < response.data.qtyConversationsHourWeek[i].length; j++) {
          let value = response.data.qtyConversationsHourWeek[i][j]
          itemArr.push({ meta: `${j}h`, value: value })
        }
        seriesArr.push(itemArr)
        itemArr = []
      }
      this.qtyConversationsHourWeek.data.series = seriesArr
    },
    setHighestIntentions (key, response) {
      this.highestIntentionsKey++
      let itemArr = []
      this[key].data.labels = response.data[key].labels
      for (let i = 0; i < response.data[key].series[0].length; i++) {
        let value = response.data[key].series[0][i]
        itemArr.push({ meta: response.data[key].labels[i], value: value })
      }
      this[key].data.series = [itemArr]
    },
    setWordsCloud (response) {
      this.wordsCloudKey++
      this.wordsCloud.words = response.data.wordsCloud
    },
    setChannelOrOs (key, response) {
      const labels = response.data.dataLabels.labels.map(elem => this.capitalize(elem))
      this[key].data.label = labels
      this[key].options.labels = labels
      if (labels.length === 1) {
        this[key].options.classNames.label = 'onlyOneLabel'
      }
      let itemArr = []
      for (let i = 0; i < response.data.dataSeries.series.length; i++) {
        let value = response.data.dataSeries.series[i]
        itemArr.push({ meta: labels[i], value: value })
      }
      this[key].data.series = itemArr
    },
    setAmountConversationInteraction (response) {
      clearTimeout(this.timeOut)
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.amountConversationInteractionKey++
          this.amountConversationInteractionDay = {
            ...this.amountConversationInteractionDay,
            data: {
              labels: [...response.data.labels],
              series: [...response.data.series]
            }
          }
          this.timeOut = setTimeout(() => {
            let pointElements = document.querySelectorAll('.custom-point-label')
            Array.from(pointElements).forEach(e => {
              e.classList.toggle('d-none', !this.showPointLabel)
            })
          }, 1000)
        })
      })
    },
    setPercentResolvedInteraction (response) {
      this.percentResolvedInteractionKey++
      const labels = response.data.data.map(elem => this.capitalize(elem.key))
      this.yes_no.data.label = labels
      this.yes_no.options.labels = labels
      if (labels.length === 1) {
        this.yes_no.options.classNames.label = 'onlyOneLabel'
      }
      let itemArr = []
      let total = response.data.data.reduce((sum, elem) => sum + elem.total, 0)
      for (let i = 0; i < response.data.data.length; i++) {
        let value = response.data.data[i].total
        itemArr.push({ meta: labels[i], value: (value > 0 ? Math.round((100 * value) / total) : 0) })
      }
      this.yes_no.data.series = itemArr
    },
    setPercentResolvedInteractionKnowledge (response) {
      this.percentResolvedInteractionKnowledgeKey++
      const labels = response.data.data.map(elem => this.capitalize(elem.key))
      this.yes_no_kb.data.label = labels
      this.yes_no_kb.options.labels = labels
      if (labels.length === 1) {
        this.yes_no_kb.options.classNames.label = 'onlyOneLabel'
      }
      let itemArr = []
      let total = response.data.data.reduce((sum, elem) => sum + elem.total, 0)
      for (let i = 0; i < response.data.data.length; i++) {
        let value = response.data.data[i].total
        itemArr.push({ meta: labels[i], value: (value > 0 ? Math.round((100 * value) / total) : 0) })
      }
      this.yes_no_kb.data.series = itemArr
    },
    setPercentResolvedInteractionBoth (response) {
      this.percentResolvedInteractionBothKey++
      const labels = response.data.data.map(elem => this.capitalize(elem.key))
      this.yes_no_both.data.label = labels
      this.yes_no_both.options.labels = labels
      if (labels.length === 1) {
        this.yes_no_both.options.classNames.label = 'onlyOneLabel'
      }
      let itemArr = []
      let total = response.data.data.reduce((sum, elem) => sum + elem.total, 0)
      for (let i = 0; i < response.data.data.length; i++) {
        let value = response.data.data[i].total
        itemArr.push({ meta: labels[i], value: (value > 0 ? Math.round((100 * value) / total) : 0) })
      }
      this.yes_no_both.data.series = itemArr
    },
    setQtyConversationsByHost (response) {
      this.qtyConversationsByHostKey++
      this.qtyConversationsByHost.data.labels = []
      this.qtyConversationsByHost.data.series[0] = []
      response.data.qtyConversationsByHost.labels.forEach((elem, index) => {
        this.qtyConversationsByHost.data.labels.push(elem)
        this.qtyConversationsByHost.data.series[0].push({
          meta: elem,
          value: response.data.qtyConversationsByHost.series[index]
        })
      })
    },
    mountTooltip (meta, value) {
      let tooltipMeta = "<span style='font-weight: bold'>" + meta + '</span>'
      let tooltipValue = '<span> Valor: ' + value + '</span>'
      return tooltipMeta + '<br/>' + tooltipValue
    },
    capitalize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    labelColor (index) {
      switch (index) {
        case 0:
          return 'text-info'
        case 1:
          return 'text-danger'
        case 2:
          return 'text-warning'
        case 3:
          return 'text-primary'
        case 4:
          return 'text-success'
        case 5:
          return 'text-dribbble'
        case 6:
          return 'text-tumblr'
      }
    },
    isDashboardSelect (type) {
      const tenants = {
        regularize: true,
        yaraltm: true,
        demo: true,
        ima: true,
        sefmg: true,
        default: false
      }
      return tenants[type] || tenants.default
    },
    changePointLabel () {
      let pointElements = document.querySelectorAll('.custom-point-label')
      requestAnimationFrame(() => {
        Array.from(pointElements).forEach(e => e.classList.toggle('d-none'))
      })
    }
  },
  created () {
    if (this.tenant === 'ima' || this.tenant === 'ipmc' || this.tenant === 'sesam') {
      this.$router.push('/templates')
    }
  }
}
</script>
<style lang="scss" scoped>

[v-cloak] {
  display: none;
}

.amount-conversation-interaction {
  contain: content;
  will-change: contents;
  content-visibility: auto;
  contain-intrinsic-size: 400px;
}

.custom-point-label {
  will-change: contents;
}

.wordCloud {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 7px;
  background-color: whitesmoke;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}
#reports .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}
.text-dribbble {
  color: #ea4c89;
}
.text-tumblr {
  color: #3c4858;
}
.color-blue-olive {
  color: #A8DCFF;
}
.color-blue-50 {
  color: #3245B1;
}

.ct-series .ct-line {
  transition: none;
}

.ct-series.ct-series-a .customLine {
    stroke: #8ED2FF !important;
}
.percentChart .ct-series-a .ct-slice-pie {
  fill: #00bcd4 !important;
}

.percentChart .ct-series-b .ct-slice-pie {
  fill: #f44336 !important;

}
.percentChart .ct-label {
  fill: rgb(255, 255, 255) !important;
  font-weight: 600;
}

.ct-chart-bar {
  text {
    visibility: hidden !important;
  }
}

.evaluationSLO {
    #chatList > .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
    white-space: normal !important;
    overflow: initial !important;
    text-overflow: initial !important;
    width: 100%;
    text-align: left;
  }

  @media (max-width: 850px) {
  #chatList > .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
    font-size: 12px;
    line-height: 20px;
  }
}
}
</style>
